export class FilterListObject {
  constructor() {
    this.Value = "";
    this.Desc = "";
    this.Selected = false;
  }

  Build(val:string, desc:string, sel:boolean):FilterListObject {
    this.Value = val;
    this.Desc = desc;
    this.Selected = sel;
    return this;
  }

  public Value: string;
  public Desc: string;
  public Selected: boolean;
}
